module.exports = __webpack_public_path__ + "img/3.064a22ae.jpg";